/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcademicProfileAssessmentNotificationRequest } from '../models/AcademicProfileAssessmentNotificationRequest';
import type { AcademicProfileAssessmentRequest } from '../models/AcademicProfileAssessmentRequest';
import type { AcademicProfileAssessmentResponse } from '../models/AcademicProfileAssessmentResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AcademicProfileAssessmentRestControllerService {
  /**
   * getProfileAssessment
   * @returns AcademicProfileAssessmentResponse OK
   * @throws ApiError
   */
  public static getProfileAssessmentUsingGet({
    profileTemplateId,
    studentId,
  }: {
    /**
     * profileTemplateId
     */
    profileTemplateId: string;
    /**
     * studentId
     */
    studentId: string;
  }): CancelablePromise<AcademicProfileAssessmentResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/academic-profile-assessment',
      query: {
        profileTemplateId: profileTemplateId,
        studentId: studentId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * saveProfileAssessment
   * @returns any OK
   * @throws ApiError
   */
  public static saveProfileAssessmentUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: AcademicProfileAssessmentRequest;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/academic-profile-assessment',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * sendProfileAssessmentNotification
   * @returns any OK
   * @throws ApiError
   */
  public static sendProfileAssessmentNotificationUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: AcademicProfileAssessmentNotificationRequest;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/academic-profile-assessment/notification',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getProfileAssessmentWithDataSourceValues
   * @returns AcademicProfileAssessmentResponse OK
   * @throws ApiError
   */
  public static getProfileAssessmentWithDataSourceValuesUsingGet({
    profileTemplateId,
    studentId,
  }: {
    /**
     * profileTemplateId
     */
    profileTemplateId: string;
    /**
     * studentId
     */
    studentId: string;
  }): CancelablePromise<AcademicProfileAssessmentResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/academic-profile-assessment/with-data-source',
      query: {
        profileTemplateId: profileTemplateId,
        studentId: studentId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
